import clsx from "clsx";
import dayjs from "dayjs";

import { DateTimeTz, Icon } from "@web-app/components";
import { OrderDeliveryTypeText, OrderTimeline } from "@web-app/types";
import {
  EntityPresentationType,
  OrderTimelineSchema,
  timeZoneMap,
} from "@web-app/utils/helpers";

type ScheduleTimeActivityPropTypes = {
  deliveryType: OrderDeliveryTypeText;
  item: OrderTimeline;
  showTimelineBar: boolean;
  timezone: keyof typeof timeZoneMap | undefined;
};

export default function ScheduleTimeActivity({
  item,
  showTimelineBar,
  deliveryType,
  timezone,
}: ScheduleTimeActivityPropTypes) {
  const ScheduledTimeActivityIcon =
    OrderTimelineSchema[item.entity].action[item.action].icon;
  const scheduledTimeActivityColor =
    OrderTimelineSchema[item.entity].action[item.action].color;

  return (
    <li key={item.id} className="relative flex gap-x-2 md:gap-x-4">
      <div
        className={clsx(
          showTimelineBar ? "-bottom-6" : "h-6",
          "absolute left-0 top-0 flex w-6 justify-center",
        )}
      >
        <div className="w-px bg-gray-200" />
      </div>
      <div className="relative flex h-7 w-6 flex-none items-center justify-center bg-white">
        <Icon
          name={ScheduledTimeActivityIcon}
          className={clsx("h-3 md:h-4", scheduledTimeActivityColor)}
        />
      </div>
      <p className="flex-auto flex flex-col items-start py-0.5 text-[10px] md:text-xs leading-0 md:leading-5 text-gray-500">
        <span
          className={clsx(
            "inline-block font-medium text-gray-900",
            scheduledTimeActivityColor,
          )}
        >
          {deliveryType === "Individual"
            ? `${OrderTimelineSchema[item.entity].action[item.action].text} ${
                // @ts-ignore typed any
                OrderTimelineSchema[item.entity].entityPresentation[
                  "individual"
                ] as Partial<EntityPresentationType>
              }
                      ${
                        item.previousValue &&
                        item.updatedValue &&
                        ` from ${dayjs(item.previousValue).format(
                          "MM-DD-YYYY HH:mm",
                        )} to ${dayjs(item.updatedValue).format(
                          "MM-DD-YYYY HH:mm",
                        )}`
                      }
                      `
            : deliveryType === "Route based drop-off"
              ? `${OrderTimelineSchema[item.entity].action[item.action].text} ${
                  // @ts-ignore typed any
                  OrderTimelineSchema[item.entity].entityPresentation[
                    "dropoff"
                  ] as Partial<EntityPresentationType>
                }${
                  item.previousValue &&
                  item.updatedValue &&
                  ` from ${dayjs(item.previousValue).format(
                    "MM-DD-YYYY HH:mm",
                  )} to ${dayjs(item.updatedValue).format("MM-DD-YYYY HH:mm")}`
                }`
              : deliveryType === "Route based pickup"
                ? `${OrderTimelineSchema[item.entity].action[item.action].text} ${
                    // @ts-ignore typed any
                    OrderTimelineSchema[item.entity].entityPresentation[
                      "pickup"
                    ] as Partial<EntityPresentationType>
                  }
                        ${
                          item.previousValue &&
                          item.updatedValue &&
                          ` from ${dayjs(item.previousValue).format(
                            "MM/DD/YYYY hh:mm A",
                          )} to ${dayjs(item.updatedValue).format(
                            "MM/DD/YYYY hh:mm A",
                          )}`
                        }`
                : ""}
        </span>
        <span className="relative">
          <DateTimeTz
            start={new Date(item?.createdAt)}
            timezone={timezone}
            createdBy={item?.createdBy?.name}
            presentation="timeline"
          />
        </span>
      </p>
    </li>
  );
}
